import TYPES from '../../../../../../../Fields'

export const getChileFieldsSchema = ({intl, dependencies}) => {
  const DOCUMENTS_CHL = TYPES.DOCUMENTS_CHL(intl, dependencies)

  return [[DOCUMENTS_CHL]]
}
